module.exports = __webpack_public_path__ + "static/media/waterDrops.1a7de246.png";